import GenAiInfoPanel from './GenAiInfoPanel'

export default GenAiInfoPanel
